const HAPPY_MOODS = new Set(['happy', 'full', '开心', '饱饱的'])
const HUNGRY_MOODS = new Set(['hungry', '饿了'])
const ACTIVE_STATES = new Set([
  'idle',
  'hover',
  'happy',
  'feeding',
  'hungry',
  'dragOver',
  'thinking',
  'analyzing',
  'success',
  'catching',
  'sad',
  'sleeping',
])

const SIZE_ALIASES = {
  fab: 'small',
  lg: 'large',
  md: 'medium',
  option: 'small',
  panel: 'large',
  sm: 'small',
}

function normalizeMood(mood, state) {
  if (state === 'hungry' || state === 'sad') return 'hungry'
  if (state === 'dragOver' || state === 'analyzing' || state === 'thinking' || state === 'hover') return 'eager'
  if (state === 'feeding' || state === 'success' || state === 'catching' || state === 'happy') return 'happy'
  if (HAPPY_MOODS.has(mood)) return 'happy'
  if (HUNGRY_MOODS.has(mood)) return 'hungry'
  return 'normal'
}

function normalizeState(state) {
  return ACTIVE_STATES.has(state) ? state : 'idle'
}

function normalizeSize(size) {
  return SIZE_ALIASES[size] || size || 'medium'
}

function PetFace({
  beak = false,
  eyeLeft = 25,
  eyeRight = 39,
  eyeY = 32,
  mouthY = 42,
  muzzle = false,
  nose = false,
  whiskers = false,
}) {
  return (
    <g className="pet-face">
      {muzzle && <ellipse className="pet-muzzle" cx="32" cy={mouthY - 1} rx="10" ry="7" />}
      <g className="pet-eye pet-eye-left">
        <circle className="pet-eye-dot" cx={eyeLeft} cy={eyeY} r="2.8" />
        <path className="pet-eye-smile" d={`M${eyeLeft - 4} ${eyeY}q4 4 8 0`} />
        <path className="pet-eye-sad" d={`M${eyeLeft - 4} ${eyeY + 2}q4 -2 8 0`} />
        <circle className="pet-eye-shine" cx={eyeLeft + 1.2} cy={eyeY - 1.2} r="1.1" />
      </g>
      <g className="pet-eye pet-eye-right">
        <circle className="pet-eye-dot" cx={eyeRight} cy={eyeY} r="2.8" />
        <path className="pet-eye-smile" d={`M${eyeRight - 4} ${eyeY}q4 4 8 0`} />
        <path className="pet-eye-sad" d={`M${eyeRight - 4} ${eyeY + 2}q4 -2 8 0`} />
        <circle className="pet-eye-shine" cx={eyeRight + 1.2} cy={eyeY - 1.2} r="1.1" />
      </g>
      {nose && <path className="pet-nose" d={`M32 ${mouthY - 4}l-3.7 2.9h7.4L32 ${mouthY - 4}Z`} />}
      {beak && <path className="pet-beak" d={`M32 ${mouthY - 8}l-6 4.3h12L32 ${mouthY - 8}Z`} />}
      {whiskers && (
        <g className="pet-whiskers">
          <path d={`M13 ${mouthY - 7}h10M13 ${mouthY - 1}h10M41 ${mouthY - 7}h10M41 ${mouthY - 1}h10`} />
        </g>
      )}
      <path className="pet-mouth pet-mouth-normal" d={`M27 ${mouthY}q5 2.8 10 0`} />
      <path className="pet-mouth pet-mouth-happy" d={`M26.5 ${mouthY - 1}q5.5 6 11 0`} />
      <path className="pet-mouth pet-mouth-sad" d={`M27 ${mouthY + 3}q5 -4 10 0`} />
      <path className="pet-mouth pet-mouth-eager" d={`M27.5 ${mouthY}h9`} />
      <g className="pet-thinking-dots">
        <circle cx="43" cy="17" r="1.9" />
        <circle cx="48" cy="13" r="1.4" />
        <circle cx="52" cy="9.5" r="1" />
      </g>
    </g>
  )
}

function PetEffects() {
  return (
    <g className="pet-avatar-effects" aria-hidden="true">
      <path className="pet-effect-heart" d="M18 12c-3-4-9 0-5 5l5 5 5-5c4-5-2-9-5-5Z" />
      <path className="pet-effect-star" d="M47 12l1.7 4 4.3.4-3.3 2.8 1 4.2-3.7-2.2-3.7 2.2 1-4.2-3.3-2.8 4.3-.4L47 12Z" />
      <path className="pet-effect-spark" d="M17 49l1.2 2.5 2.8.4-2 1.9.5 2.8-2.5-1.4-2.5 1.4.5-2.8-2-1.9 2.8-.4L17 49Z" />
    </g>
  )
}

function RobotSvg() {
  return (
    <svg className="pet-avatar-svg" viewBox="0 0 64 64" role="img" focusable="false">
      <ellipse className="pet-ground-shadow" cx="32" cy="56" rx="17" ry="4" />
      <g className="pet-avatar-body">
        <path className="pet-accent pet-antenna" d="M32 18v-6" />
        <circle className="pet-accent-fill" cx="32" cy="9.5" r="4" />
        <rect className="pet-primary" x="16" y="18" width="32" height="31" rx="12" />
        <rect className="pet-face-plate" x="20" y="23" width="24" height="21" rx="9" />
        <path className="pet-primary pet-side" d="M12 31h5M47 31h5" />
        <rect className="pet-secondary" x="23" y="49" width="18" height="5" rx="2.5" />
        <PetFace eyeY={32} mouthY={39} />
      </g>
      <PetEffects />
    </svg>
  )
}

function CatSvg() {
  return (
    <svg className="pet-avatar-svg" viewBox="0 0 64 64" role="img" focusable="false">
      <ellipse className="pet-ground-shadow" cx="32" cy="56" rx="18" ry="4" />
      <g className="pet-avatar-body">
        <path className="pet-primary" d="M17 30 15 15l12 8h10l12-8-2 15" />
        <path className="pet-ear-inner" d="M20 22l-1-4 4 3ZM44 22l1-4-4 3Z" />
        <circle className="pet-secondary" cx="32" cy="35" r="19" />
        <path className="pet-cheek" d="M19 40c4 9 22 9 26 0v3c-2 8-9 13-13 13s-11-5-13-13v-3Z" />
        <PetFace eyeY={33} mouthY={42} nose whiskers />
      </g>
      <PetEffects />
    </svg>
  )
}

function DogSvg() {
  return (
    <svg className="pet-avatar-svg" viewBox="0 0 64 64" role="img" focusable="false">
      <ellipse className="pet-ground-shadow" cx="32" cy="56" rx="18" ry="4" />
      <g className="pet-avatar-body">
        <path className="pet-primary pet-ear-left" d="M18 25c-8 5-10 18-4 23 6 5 12-3 11-13" />
        <path className="pet-primary pet-ear-right" d="M46 25c8 5 10 18 4 23-6 5-12-3-11-13" />
        <circle className="pet-secondary" cx="32" cy="35" r="19" />
        <path className="pet-spot" d="M22 20c6-5 18-4 23 4-8 0-14 2-21 8-2-3-3-7-2-12Z" />
        <PetFace eyeY={33} mouthY={43} muzzle nose />
      </g>
      <PetEffects />
    </svg>
  )
}

function PenguinSvg() {
  return (
    <svg className="pet-avatar-svg" viewBox="0 0 64 64" role="img" focusable="false">
      <ellipse className="pet-ground-shadow" cx="32" cy="57" rx="17" ry="4" />
      <g className="pet-avatar-body">
        <ellipse className="pet-primary" cx="32" cy="35" rx="18" ry="22" />
        <ellipse className="pet-face-plate" cx="32" cy="39" rx="12" ry="15" />
        <path className="pet-flipper" d="M15 39c-5 4-6 10-2 13M49 39c5 4 6 10 2 13" />
        <path className="pet-foot" d="M23 55h8M33 55h8" />
        <PetFace eyeY={30} mouthY={41} beak />
      </g>
      <PetEffects />
    </svg>
  )
}

function FoxSvg() {
  return (
    <svg className="pet-avatar-svg" viewBox="0 0 64 64" role="img" focusable="false">
      <ellipse className="pet-ground-shadow" cx="32" cy="56" rx="18" ry="4" />
      <g className="pet-avatar-body">
        <path className="pet-primary" d="M15 17l12 8h10l12-8-5 25c-2 9-8 14-12 14s-10-5-12-14L15 17Z" />
        <path className="pet-ear-inner" d="M19 20l4 8 5-4ZM45 20l-4 8-5-4Z" />
        <path className="pet-secondary" d="M21 24l10 14-9 12c-4-5-5-13-1-26ZM43 24 33 38l9 12c4-5 5-13 1-26Z" />
        <path className="pet-face-plate" d="M25 41h14l-7 11-7-11Z" />
        <path className="pet-tail" d="M47 42c8 2 10 10 4 14-4 2-9-1-10-6 4 2 7 1 9-1-1-3-4-5-7-6Z" />
        <PetFace eyeY={34} mouthY={43} nose />
      </g>
      <PetEffects />
    </svg>
  )
}

const PET_SVGS = {
  robot: RobotSvg,
  cat: CatSvg,
  dog: DogSvg,
  penguin: PenguinSvg,
  fox: FoxSvg,
}

function PetAvatar({
  className = '',
  mood = 'normal',
  size = 'md',
  state = 'idle',
  type = 'robot',
}) {
  const normalizedType = PET_SVGS[type] ? type : 'robot'
  const normalizedState = normalizeState(state)
  const normalizedMood = normalizeMood(mood, normalizedState)
  const normalizedSize = normalizeSize(size)
  const AvatarSvg = PET_SVGS[normalizedType]

  return (
    <span
      className={[
        'pet-avatar-art',
        `pet-avatar-${normalizedType}`,
        `pet-avatar-${normalizedSize}`,
        className,
      ].filter(Boolean).join(' ')}
      data-mood={normalizedMood}
      data-state={normalizedState}
      aria-hidden="true"
    >
      <AvatarSvg />
    </span>
  )
}

export default PetAvatar
